import { FC } from 'react';
import { IReviews } from '@/interfaces/reviews.interface';
import { removeAllBrackertsFromString } from '@/helpers/helpers';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IEbookJsonMarkup {
  book: IBookShortDetail;
  authorFullName: string;
  reviews: IReviews;
}

const EbookJsonMarkup: FC<IEbookJsonMarkup> = ({ book, authorFullName, reviews }) => {
  const bookType = book.book.type === 'book' || book.book.type === 'pdf' ? `Book` : `Audiobook`;

  const readUrl = `https://fenzin.org/online/${book.alias}`;
  const description = removeAllBrackertsFromString(`${book.book.description}`);

  const reviewsContent = `
    "review": {
      "@type": "Review",
      "author": {"@type": "Person", "name": "${!!reviews.data ? reviews.data[0]?.name : ''}"},
      "reviewBody": "${!!reviews.data ? reviews.data[0]?.message : ''}"},`;

  const getBookJsonMarkup = () => {
    return {
      __html: `
      { "@context": "https://schema.org","@type": "${bookType}",
          "bookFormat": "https://schema.org/EBook","name":"${book.book.title}",
          "author": {"@type": "Person","name": "${authorFullName}"},
          "illustrator": {"@type": "Person","name": "${authorFullName}"},
          "abstract": "${description}",
        "workExample": {"@type": "${bookType}",
          "url": "${readUrl}","name": "Читать первую главу бесплатно"},
        "aggregateRating": {"@type": "AggregateRating","ratingValue": "${book.rating}","bestRating": "5","ratingCount": "${book.voted_users}"},
        ${!!reviews.data && reviews.data.length > 0 ? reviewsContent : ``}
        "accessibilityFeature": ["largePrint","highContrast","alternativeText"],
        "potentialAction": {"@type": "ReadAction","target": "${readUrl}"}
      }`,
    };
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={getBookJsonMarkup()} key="product-jsonld" />;
};

export default EbookJsonMarkup;
